/**
 * Application constants
 */

export const APP_NAME = "Snapes Logistics";
export const APP_COPYRIGHT = "© 2024 Snapes Logistics. All rights reserved.";

export const BREAKPOINTS = {
  mobile: 576,
  tablet: 992,
  desktop: 992,
} as const;

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  LOGOUT: "/logout",

  // Client routes
  CLIENT_DASHBOARD: "/client",
  CLIENT_QUOTES_NEW: "/client/quotes/new",
  CLIENT_QUOTES_DETAIL: "/client/quotes/$id",
  CLIENT_ADDRESSES: "/client/addresses",
  CLIENT_PROFILE: "/client/profile",

  // Operations routes
  OPERATIONS_DASHBOARD: "/operations",
  OPERATIONS_QUEUE: "/operations/queue",
  OPERATIONS_QUOTES_DETAIL: "/operations/quotes/$id",
  OPERATIONS_QUOTES_ADJUST: "/operations/quotes/$id/adjust",

  // Admin routes
  ADMIN_DASHBOARD: "/admin",
  ADMIN_ORGANIZATIONS: "/admin/organizations",
  ADMIN_ORGANIZATION_MARGINS: "/admin/organizations/$id/margins",
  ADMIN_RATE_CARDS: "/admin/rate-cards",
  ADMIN_SETTINGS: "/admin/settings",
} as const;

export const USER_ROLES = {
  CLIENT: "client",
  OPERATIONS: "operations",
  ADMIN: "admin",
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

/**
 * Quote reference number configuration
 */
export const QUOTE_REFERENCE = {
  /**
   * Prefix for quote reference numbers
   * Format: {PREFIX}-{YEAR}-{SEQUENTIAL}
   * Example: SVQ-2026-00001
   */
  PREFIX: "SVQ",
} as const;

/**
 * Maximum value for decimal(10,2) DB columns to prevent overflow
 */
export const MAX_COST_DECIMAL_10_2 = 99_999_999.99;

export {
  CONNOTE_NUMBER_REFERENCE_MAX_LENGTH,
  ORDER_REFERENCE_MAX_LENGTH,
} from "./quote-reference";
export {
  ZONES,
  ZONE_OPTIONS,
  getZoneName,
  getZoneCode,
  type ZoneId,
} from "./zones";
export {
  ADDRESS_ACCESS_CONDITIONS,
  ADDRESS_ACCESS_CONDITION_CODES,
  addressAccessConditionRequiresValue,
  formatAddressAccessCondition,
  getAddressAccessConditionLabel,
  type AddressAccessCondition,
  type AddressAccessConditionCode,
} from "./address-access";
